module.exports = __webpack_public_path__ + "img/icon-user.5b6c41d0.svg";